module.exports = __webpack_public_path__ + "img/Hypoxia-BRME_GSE179572.e5fef765.png";